interface UrlDetails {
  lang: string
  page: string
}

export const getUrlDetails = (langs: string[], url: string): UrlDetails => {
  const REGEX_LANG = 'lang'
  const REGEX_PAGE = 'page'

  let lang = null
  let page = null

  try {
    const regex = new RegExp(`(\/(?<${REGEX_LANG}>${langs.join('|')}))?(\/(?<${REGEX_PAGE}>.*))?`, 'g')

    for (const match of url.matchAll(regex)) {
      if (match.groups[REGEX_LANG]) lang = match.groups[REGEX_LANG]
      if (match.groups[REGEX_PAGE]) page = match.groups[REGEX_PAGE].split('?')[0]
    }
  } catch (e) {
    console.info(e)
  }

  return {lang, page}
}
